module.exports = __webpack_public_path__ + "img/20191010170911718.2c28fc15.jpg";